import { render } from "./ManageBeneficiaries.vue?vue&type=template&id=47e6ecda&scoped=true"
import script from "./ManageBeneficiaries.vue?vue&type=script&lang=js"
export * from "./ManageBeneficiaries.vue?vue&type=script&lang=js"

import "./ManageBeneficiaries.vue?vue&type=style&index=0&id=47e6ecda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e6ecda"]])

export default __exports__